<template>
    <a-segmented
        :options="computedGenderOptions"
        :value="value"
        @change="handleGenderChange"
        block
        class="custom-segmented"
    >
    </a-segmented>
</template>

<script>
import { GenderEnum } from '@/enums/common.enums';

export default {
    name: 'GenderSelect',
    props: {
        gender: {
            type: String,
            required: true,
        },
        width: {
            type: String,
            required: false,
            default: '100%',
        },
        margin: {
            type: String,
            required: false,
            default: '0px',
        },
        language: {
            type: String,
            required: false,
        },
    },
    computed: {
        // computed 안에서 $t를 호출하므로 locale 변경에 반응해 다시 계산된다(스냅샷 아님).
        computedGenderOptions() {
            return [
                {
                    label: this.$t('workorder_gender_male'),
                    value: GenderEnum.MALE,
                },
                {
                    label: this.$t('workorder_gender_female'),
                    value: GenderEnum.FEMALE,
                },
                {
                    label: this.$t('workorder_gender_none'),
                    value: '',
                },
            ];
        },
    },
    data() {
        return {
            GenderEnum,
            value: this.gender,
        }
    },
    watch: {
        gender(newValue) {
            this.value = newValue;
        }
    },
    methods: {
        handleGenderChange(value) {
            this.value = value;
            this.$emit('handle-gender-change', value);
        }
    }
}
</script>

<style lang="scss" scoped>
.custom-segmented {
    :deep {
        .ant-segmented-item-label {
            padding: 4px 0;
            font-size: 14px !important;
            color: #666;
        }

        .ant-segmented-item-selected {
            .ant-segmented-item-label {
                font-weight: 500;
                word-break: break-all !important;
            }
        }
    }
}
</style>

<style lang="scss">
.ant-segmented-item{
    margin-bottom: 0px !important;
}
</style>
